import React, { useState } from "react";
import NetaqInput from "./NetaqInput";
import ActionButton from "./ActionButton";
import { useTranslate } from "./TranslationText";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";
import NewActionButton from "./ActionButtons/NewActionButton";

const CoursesFilter = ({ onSubmit }) => {
  const [checker, setChecker] = useState(true);
  const { translate } = useTranslate();
  const [dateStartFrom, setDateStartFrom] = useState(null);
  const [dateStartTo, setDateStartTo] = useState(null);

  const [filterState, setFilterState] = useState({
    // Initial filter values
    coursTitle: "",
    coursecategory: "both",
    DateFrom: "",
    DateTo: "",
  });


  const handleChange = (event, input) => {
    if (!!input && input === "DateFrom") {
      setDateStartFrom(event)
      setFilterState({
        ...filterState,
        DateFrom: event.$d.toISOString(),
      });
      return;
    }
    if (!!input && input === "DateTo") {
      setDateStartTo(event)
      setFilterState({
        ...filterState,
        DateTo: event.$d.toISOString(),
      });
      return;
    }
    const value = event.target.type == 'checkbox' ? event.target.checked : event.target.value
    setFilterState({
      ...filterState,
      [event.target.name]: value,
    });


  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    onSubmit(filterState); // Pass filter state to News
  };
  const handleReset = (event) => {
    window.scrollTo(0, 0);

    setDateStartFrom(null)
    setDateStartTo(null)

    setFilterState({
      coursTitle: "",
      coursecategory: "all",
      DateFrom: "",
      DateTo: "",
    });
  };



  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.simplesearch', 'Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={'coursTitle'}
          label={translate("web.courseTitle", "Course Title")}
          key={"search"}
          placeholder={translate("web.courseTitle", "Course Title")}
          type={"text"}
          onChange={handleChange}
        />
      </div>

      <div className="row mb-form-group-last">
        <div className="col-6">
          <NetaqInput
            name={"DateFrom"}
            key={"DateFrom"}
            type={"date"}

            label={
              <>
                {translate("web.date", "Date")} {translate("web.from", "From")}
              </>
            }
            onChange={handleChange}
            value={dateStartFrom}
          />
        </div>
        <div className="col-6">
          <NetaqInput
            name={"DateTo"}
            key={"DateTo"}
            type={"date"}
            label={
              <>
                {translate("web.date", "Date")} {translate("web.to", "To")}
              </>
            }
            onChange={handleChange}
            value={dateStartTo}
            minDate={dateStartFrom}
          />
        </div>
      </div>
      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          />
        </div>
      </div>
    </form>
  );
};

export default CoursesFilter;
